import { createStore } from 'vuex';
import AuthService from '../services/auth';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

// Get theme from localStorage or default to 'light'
const theme = localStorage.getItem('theme') || 'light';

export default createStore({
  state: {
    ...initialState,
    theme: theme
  },
  getters: {
    isLoggedIn(state) {
      return state.status.loggedIn;
    },
    currentUser(state) {
      return state.user;
    },
    currentTheme(state) {
      return state.theme;
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    setTheme(state, theme) {
      state.theme = theme;
      localStorage.setItem('theme', theme);
      document.body.setAttribute('data-theme', theme);
    }
  },
  actions: {
    login({ commit }, { username, password }) {
      return AuthService.login(username, password).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    changeTheme({ commit }, theme) {
      commit('setTheme', theme);
    }
  },
  modules: {}
});
